import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token (fallback when cookies blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("mara_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  // Multi-tenant: send active tenant slug (super_admin tenant switcher)
  const ts = localStorage.getItem("mara_tenant_slug");
  if (ts) {
    config.headers = config.headers || {};
    config.headers["X-Tenant-Slug"] = ts;
  }
  return config;
});

export function setActiveTenantSlug(slug) {
  if (slug) localStorage.setItem("mara_tenant_slug", slug);
  else localStorage.removeItem("mara_tenant_slug");
}

export function getActiveTenantSlug() {
  return localStorage.getItem("mara_tenant_slug") || "";
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export default api;
